<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-theme-9 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        GR
      </div>
      <h2 class="text-lg font-medium ml-4">
        {{ formGR.grEdit ? 'แก้ไข GR ' + formGR.docNoFull : 'สร้าง GR' }}
      </h2>
      <OverBudget />
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <router-link
        type="button"
        :to="{ name: 'procurementGRWait' }"
        class="btn box text-gray-700 flex items-center"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectGR()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <button
        type="button"
        class="btn box text-gray-700 disabled:opacity-50 flex items-center"
        @click.prevent="saveGR(true)"
        :disabled="btnDraft.disabled"
        v-show="!btnDraft.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDraft.loading"
        />
        <LoadingIcon icon="oval" color="blue" v-else class="w-4 h-4 mr-2" />
        บันทึกแบบร่าง
      </button>
      <button
        type="button"
        class="btn btn-primary disabled:opacity-50 flex items-center"
        @click.prevent="saveGR(false)"
        :disabled="btnSave.disabled"
        v-show="!btnSave.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnSave.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        บันทึก และส่งอนุมัติ
      </button>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-5" v-if="formGR.isEdit">
            <DocumentPath
              :document-path="formGR.documentPathArray"
              :status-code="formGR.statusCode"
              :next-status-code="formGR.nextStatus"
              :approve-result="formGR.approveResultArray"
            />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
            <!-- logo -->
            <div class="col-span-1 md:mr-4 box flex flex-col justify-center">
              <div
                class="w-full h-auto flex flex-row justify-center bg-white p-4"
              >
                <img
                  v-if="companyDefault"
                  :src="companyDefault.comp_logo_url"
                  class=""
                  alt=""
                />
              </div>
            </div>
            <div class="col-span-2 lg:col-span-4 mt-4 md:mt-0">
              <!-- ตำแหน่งเอกสาร -->
              <div class="intro-y box p-5">
                <div class="flex flex-col lg:flex-row lg:space-x-4">
                  <div class="text-theme-6">
                    ตำแหน่งเอกสาร : ฝ่ายจัดซื้อดำเนินการ
                  </div>
                  <div class="text-theme-10">
                    ผู้ดำเนินการ : {{ userInfo ? userInfo.fullname : '' }}
                  </div>
                </div>
              </div>
              <!-- สายอนุมัติของผู้เปิดเอกสาร -->
              <div class="intro-y box p-5 mt-5 lg:flex lg:justify-between">
                <div>
                  <div>สายอนุมัติของผู้เปิดเอกสาร :</div>
                  <div class="font-bold">
                    {{
                      documentPathText
                        ? documentPathText.join(' -> ')
                        : 'ไม่ระบุ'
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box intro-y mt-5 p-5">
            <div class="text-lg font-bold">
              ข้อมูลผู้สร้างเอกสาร
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-5">
              <!-- ชื่อผู้ขอเบิก -->
              <div>
                <div class="w-full">
                  <label class="form-label">ชื่อผู้ขอเบิก </label>
                  <div class="preview w-full">
                    <WfSelectSingleEmployee
                      :disabled="lockField.status"
                      key="wfselect-employee"
                      v-model="formGR.employeeSelected"
                      :showBtnClear="false"
                      :options="{
                        searchMinLength: 3
                      }"
                      @change="onChangeDocumentPath"
                    ></WfSelectSingleEmployee>
                  </div>
                  <span class="text-theme-6" v-show="lockField.status">{{
                    lockField.label
                  }}</span>
                </div>
              </div>
              <!-- หน่วยงาน / บริษัท -->
              <div>
                <label class="form-label">หน่วยงาน / บริษัท </label>
                <select
                  name=""
                  v-model="formGR.companySelected"
                  @change="onChangeDocumentPath({ target: 'select-company' })"
                  class="form-select w-full"
                  :disabled="lockField.status"
                >
                  <option
                    v-for="company in companyOptions"
                    :key="company.comp_no"
                    :value="company.comp_no"
                    >{{ company.comp_name_th }}</option
                  >
                </select>
                <span class="text-theme-6" v-show="lockField.status">{{
                  lockField.label
                }}</span>
              </div>
              <!-- รหัสหน่วยงาน -->
              <div>
                <label class="form-label">รหัสหน่วยงาน</label>
                <div class="" v-if="employeeDefault">
                  {{ employeeDefault.bu_no }} ({{ employeeDefault.bu_name }})
                </div>
              </div>
              <!-- เบอร์ติดต่อ -->
              <div>
                <label class="form-label"
                  >เบอร์ติดต่อ <span class="text-theme-6">*</span></label
                >
                <div>
                  <input
                    type="text"
                    refs="titleRef"
                    v-model="validateGR.telephone.$model"
                    class="form-control w-full"
                    :class="{
                      'border-theme-6': validateGR.telephone.$error
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 mt-5">
            <div class="col-span-2">
              <!-- รายละเอียดใบสั่งซื้อ/สัญญา -->
              <div class="intro-y box p-5">
                <div class="">
                  <div class="font-bold text-lg">
                    รายละเอียดใบสั่งซื้อ/สัญญา
                  </div>
                </div>
                <div>
                  <!-- เลือก PO -->
                  <div class="mt-4">
                    <a
                      class="w-full btn btn-warning"
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#modal-po-list"
                      @click="openModalPOList"
                      v-if="!formGR.grEdit"
                    >
                      เลือก PO
                      {{ docNoFull !== null ? 'เลขที่ ' + docNoFull : '' }}
                    </a>
                    <div v-else class="font-bold">เลขที่: {{ docNoFull }}</div>
                  </div>
                  <div
                    class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4 mt-4"
                    v-show="isLoadingGRList"
                  >
                    <div class="space-y-2">
                      <!-- ผู้ค้า -->
                      <div class="">
                        <label class="form-label font-bold">ผู้ค้า:</label>
                        <div>
                          {{ formPO.vendorCode }} - {{ formPO.vendorName }}
                        </div>
                      </div>
                      <!-- ที่อยู่ -->
                      <div class="">
                        <label class="form-label font-bold">ที่อยู่:</label>
                        <div>{{ formPO.vendorAddress }}</div>
                      </div>
                      <!-- โทร -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold">โทร:</label>
                        <div>{{ formPO.vendorTelephone }}</div>
                      </div>
                      <!-- อีเมล์ -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold">Email:</label>
                        <div>{{ formPO.vendorEmail }}</div>
                      </div>
                    </div>
                    <div class="space-y-2">
                      <!-- ใบสั่งซื้อ/สัญญา -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold"
                          >ใบสั่งซื้อ/สัญญา:
                        </label>
                        <div>{{ formPO.poDocTypeText }}</div>
                      </div>

                      <!-- สกุลเงิน -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold">สกุลเงิน:</label>
                        <div>{{ formPO.currencyCode }}</div>
                      </div>
                      <!-- ชนิดของการซื้อ -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold"
                          >ชนิดของการซื้อ:</label
                        >
                        <div>{{ formPO.orderTypeText }}</div>
                      </div>
                      <!-- ส่วนลดรวม -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold">ส่วนลดรวม:</label>
                        <div>{{ numberFormat(formPO.discountAllItem) }}</div>
                      </div>
                    </div>
                  </div>
                  <!-- เหตุผลในการคัดเลือกผู้ค้า -->
                  <div class="mt-2" v-show="isLoadingGRList">
                    <label class="form-label font-bold"
                      >เหตุผลในการคัดเลือกผู้ค้า:
                    </label>
                    <div
                      v-html="
                        formPO.reasonChosenVendor
                          ? formPO.reasonChosenVendor.replaceAll('\n', '<br>')
                          : ''
                      "
                    ></div>
                  </div>
                  <div class="mt-2" v-show="isLoadingGRList">
                    <!-- รายละเอียด -->
                    <div class="col-span-2">
                      <label class="form-label font-bold">รายละเอียด:</label>
                      <div
                        v-html="
                          formPO.detail
                            ? formPO.detail.replaceAll('\n', '<br>')
                            : ''
                        "
                      ></div>
                    </div>
                  </div>
                  <div class="mt-2" v-show="isLoadingGRList">
                    <!-- ข้อสำคัญ -->
                    <div class="col-span-2">
                      <label class="form-label font-bold">ข้อสำคัญ:</label>
                      <div
                        v-html="
                          formPO.importantFactor
                            ? formPO.importantFactor.replaceAll('\n', '<br>')
                            : ''
                        "
                      ></div>
                    </div>
                  </div>
                  <div class="mt-2" v-show="isLoadingGRList">
                    <!-- ไฟล์แนบ -->
                    <div class="col-span-1">
                      <label class="form-label font-bold">ไฟล์แนบ:</label>
                      <AttachFilePreview :data="files" />
                    </div>
                  </div>
                  <div class="mt-2" v-show="isLoadingGRList">
                    <label class="form-label font-bold">Memo:</label>
                    <div v-if="formPO.ememo.id">
                      <a :href="formPO.ememo.link">{{ formPO.ememo.title }}</a>
                    </div>
                    <div v-else>
                      -
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ข้อมูลการจัดส่ง -->
            <DetailShipping
              v-show="isLoadingGRList"
              class="intro-y box p-5 lg:space-y-4 order-last mt-5 lg:mt-0"
              :shipping="formPO.shipping"
            />
          </div>
          <!-- รายละเอียดการตรวจรับ -->
          <div class="intry-y box p-5 mt-5" v-show="isLoadingGRList">
            <div class="">
              <div class="font-bold text-lg">รายละเอียดการตรวจรับ</div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <!-- ชื่อผู้ขาย/ผู้รับจ้าง -->
              <div>
                <label class="form-label font-bold"
                  >ชื่อผู้ขาย/ผู้รับจ้าง</label
                >
                <div>{{ formPO.vendorCode }} - {{ formPO.vendorName }}</div>
              </div>
              <!-- เลขที่ใบขอซื้อ -->
              <div>
                <label class="form-label font-bold">เลขที่ใบขอซื้อ:</label>
                <div>{{ formPO.prDocNoFull ? formPO.prDocNoFull : '-' }}</div>
              </div>
              <!-- เลขที่ใบสั่งซื้อ/สัญญา -->
              <div>
                <label class="form-label font-bold"
                  >เลขที่ใบสั่งซื้อ/สัญญา:</label
                >
                <div>{{ formPO.docNoFull }}</div>
              </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <!-- ใบส่งของ เลขที่ -->
              <div>
                <label class="form-label"
                  >ใบส่งของ เลขที่ <span class="text-theme-6">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="validateGR.invoiceNo.$model"
                  :class="{
                    'border-theme-6': validateGR.invoiceNo.$error
                  }"
                  maxlength="50"
                  placeholder="(ไม่เกิน 50 ตัวอักษร)"
                />
                <span class="text-theme-6" v-if="validateGR.invoiceNo.$error">{{
                  validateGR.invoiceNo.required.$message
                }}</span>
                <span class="text-xs text-gray-500"
                  >* ใบส่งของ/ใบแจ้งหนี้/ใบกำกับภาษี</span
                >
              </div>
              <!-- รับสินค้า ณ วันที่ -->
              <div>
                <label class="form-label"
                  >รับสินค้า ณ วันที่ <span class="text-theme-6">*</span></label
                >
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="validateGR.reqDate.$model"
                      :inputClass="validateGR.reqDate.$error ? 'p-invalid' : ''"
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
                <span class="text-theme-6" v-if="validateGR.reqDate.$error">{{
                  validateGR.reqDate.required.$message
                }}</span>
                <span class="text-xs text-gray-500"
                  >* รับสินค้า/รับ Inv. /กรรมการตรวจรับ ณ วันที่</span
                >
              </div>
              <!-- วันที่ใบแจ้งหนี้ -->
              <div>
                <label class="form-label"
                  >วันที่ใบแจ้งหนี้ <span class="text-theme-6">*</span></label
                >
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="validateGR.invoiceDate.$model"
                      :inputClass="
                        validateGR.invoiceDate.$error ? 'p-invalid' : ''
                      "
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
                <span
                  class="text-theme-6"
                  v-if="validateGR.invoiceDate.$error"
                  >{{ validateGR.invoiceDate.required.$message }}</span
                >
              </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <!-- GL Date -->
              <div>
                <label class="form-label">GL Date</label>
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="formGR.glDate"
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
              </div>
              <!-- งวดการตรวจรับ -->
              <div>
                <label class="form-label">งวดการตรวจรับ</label>
                <div class="form-check gap-4 mt-2">
                  <div
                    v-for="(type, ind) in instalmentOptions"
                    :key="ind"
                    class=""
                  >
                    <input
                      type="radio"
                      :id="'radio-' + ind"
                      class="form-check-input"
                      :value="type.value"
                      v-model="formGR.instalmentType"
                    /><label class="form-check-label" :for="'radio-' + ind">{{
                      type.label
                    }}</label>
                  </div>
                </div>
              </div>
              <!-- งวดที่ -->
              <div>
                <label class="form-label">งวดที่</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formGR.instalmentNo"
                />
              </div>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-4 mt-5 lg:gap-4">
              <!-- รายละเอียด -->
              <div class="col-span-3">
                <label class="form-label"
                  >รายละเอียด <span class="text-theme-6">*</span></label
                >
                <!-- <textarea
                  rows="7"
                  class="form-control"
                  v-model="validateGR.reqDetail.$model"
                  :class="{
                    'border-theme-6': validateGR.reqDetail.$error
                  }"
                  placeholder="เพิ่มเติม..."
                ></textarea> -->
                <div
                  :class="{
                    'border-theme-6 border': validateGR.reqDetail.$error
                  }"
                >
                  <TextEditor v-model="validateGR.reqDetail.$model" />
                </div>

                <span class="text-theme-6" v-if="validateGR.reqDetail.$error">{{
                  validateGR.reqDetail.required.$message
                }}</span>
              </div>
              <!-- ไฟล์แนบ -->
              <div class="">
                <label class="form-label font-bold"
                  >ไฟล์แนบ {{ fileUploadMaxSize }} MB</label
                >
                <AttachFileUpload module="gr" />
              </div>
            </div>
          </div>

          <!-- PR Item -->
          <div class="grid grid-cols-1 mt-5 box intro-y" v-show="boxItemOpen">
            <div class="box p-5">
              <div class="text-lg font-bold mb-4">รายการตรวจรับ</div>
              <div class="border p-5 rounded-lg mb-4">
                <div class="text-lg mb-4">รายละเอียดสินค้า</div>
                <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                  <div class="space-y-4">
                    <!-- หมวดหมู่สินค้า -->
                    <div class="">
                      <label for="material-gl-category" class="form-label"
                        >หมวดหมู่สินค้า</label
                      >
                      <input
                        type="text"
                        id="material-gl-category"
                        class="form-control"
                        disabled
                        v-model="formPOItem.materialInfo.material_group"
                      />
                    </div>
                    <!-- รหัสชนิดสินค้า -->
                    <div class="">
                      <label for="material-description-code" class="form-label"
                        >รหัสชนิดสินค้า</label
                      >
                      <input
                        type="text"
                        id="material-description-code"
                        class="form-control"
                        disabled
                        v-model="formPOItem.materialInfo.description_code"
                      />
                    </div>
                    <!-- ส่วนลดจากการต่อรอง -->
                    <div class="">
                      <label for="barainDiscount" class="form-label"
                        >ส่วนลดจากการต่อรอง</label
                      >
                      <textarea
                        id="barainDiscount"
                        class="form-control"
                        rows="5"
                        v-model="formPOItem.bargainDiscount"
                      ></textarea>
                    </div>
                    <div>
                      <div class="text-lg mb-4">รายละเอียดการตรวจรับ</div>
                      <div
                        class="flex flex-row lg:flex-col justify-between mb-2"
                      >
                        <label class="form-label font-bold"
                          >ยอดรวมที่ทำรับไปแล้ว:</label
                        >
                        <div>{{ remain.sumActualCost }}</div>
                      </div>
                      <div
                        class="flex flex-row lg:flex-col justify-between mb-2"
                      >
                        <label class="form-label font-bold"
                          >งวดที่ทำรับล่าสุด:</label
                        >
                        <div>{{ remain.instalmentLatest }}</div>
                      </div>
                      <div
                        class="flex flex-row lg:flex-col justify-between mb-2"
                      >
                        <label class="form-label font-bold">ยอดคงเหลือ:</label>
                        <div>{{ remain.remainActualCost }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <!-- รายการสินค้า -->
                    <div class="mb-3">
                      <label for="material-description" class="form-label"
                        >รายการสินค้า <span class="text-theme-6">*</span></label
                      >
                      <textarea
                        id="material-description"
                        rows="5"
                        readonly
                        class="form-control"
                        :class="{
                          'border-theme-6':
                            validateItem.materialInfo.description.$error
                        }"
                        v-model="validateItem.materialInfo.description.$model"
                      ></textarea>
                      <span
                        class="text-theme-6"
                        v-if="validateItem.materialInfo.description.$error"
                        >{{
                          validateItem.materialInfo.description.required
                            .$message
                        }}</span
                      >
                    </div>
                    <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
                      <div class="space-y-4">
                        <!-- หน่วยนับ -->
                        <div class="">
                          <label for="material-type" class="form-label"
                            >หน่วยนับ <span class="text-theme-6">*</span></label
                          >
                          <select
                            id="material-type"
                            class="form-select form-control w-full"
                            v-model="validateItem.uomSelected.$model"
                            :class="{
                              'border-theme-6': validateItem.uomSelected.$error
                            }"
                          >
                            <option :value="null" key="0"
                              >-- เลือกหน่วยนับ --</option
                            >
                            <option
                              :value="uom.value"
                              v-for="uom in uomOptions"
                              :key="uom.value"
                              >{{ uom.label }}</option
                            >
                          </select>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.uomSelected.$error"
                            >{{
                              validateItem.uomSelected.required.$message
                            }}</span
                          >
                        </div>
                        <!-- วันที่ต้องการใช้ -->
                        <div class="">
                          <label for="" class="form-label "
                            >วันที่ต้องการใช้
                            <span class="text-theme-6">*</span></label
                          >
                          <div class="p-fluid p-grid">
                            <div class="p-field p-field-sm">
                              <Calendar
                                placeholder="2022-01-01"
                                inputStyle="padding:0.5rem 0.75rem;"
                                v-model="validateItem.useDate.$model"
                                :inputClass="
                                  validateItem.useDate.$error ? 'p-invalid' : ''
                                "
                                dateFormat="yy-mm-dd"
                              />
                            </div>
                          </div>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.useDate.$error"
                            >{{ validateItem.useDate.required.$message }}</span
                          >
                        </div>
                        <!-- สถานที่รับสินค้า -->
                        <div class="">
                          <label for="material-pickup-loc" class="form-label"
                            >สถานที่รับสินค้า
                            <span class="text-theme-6">*</span></label
                          >
                          <textarea
                            id="material-pickup-loc"
                            rows="5"
                            class="form-control"
                            :class="{
                              'border-theme-6': validateItem.pickupLoc.$error
                            }"
                            v-model="validateItem.pickupLoc.$model"
                          ></textarea>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.pickupLoc.$error"
                            >{{
                              validateItem.pickupLoc.required.$message
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="space-y-4">
                        <!-- เลือกประเภทการใช้ราคา -->
                        <div class="">
                          <label for="material-price" class="form-label"
                            >เลือกประเภทการใช้ราคา</label
                          >
                          <div class="form-check gap-4">
                            <div>
                              <input
                                type="radio"
                                class="form-check-input"
                                id="use-price-po"
                                value="po"
                                v-model="formPOItem.usePriceType"
                              /><label
                                class="form-check-label"
                                for="use-price-po"
                                >ใช้ราคาตาม PO</label
                              >
                            </div>
                            <div>
                              <input
                                type="radio"
                                class="form-check-input"
                                id="use-price-new"
                                value="new"
                                v-model="formPOItem.usePriceType"
                              /><label
                                class="form-check-label"
                                for="use-price-new"
                                >ระบุราคาใหม่</label
                              >
                            </div>
                          </div>
                        </div>
                        <!-- ราคาต่อหน่วย -->
                        <div class="">
                          <label for="material-price" class="form-label"
                            >ราคาต่อหน่วย
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-price"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6':
                                validateItem.materialInfo.price.$error
                            }"
                            v-model.number="
                              validateItem.materialInfo.price.$model
                            "
                            @keyup="summaryAmount"
                            @change="summaryAmount"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.materialInfo.price.$error"
                            >{{
                              validateItem.materialInfo.price.required.$message
                            }}</span
                          >
                        </div>
                        <!-- จำนวนหน่วย -->
                        <div class="">
                          <label for="material-quality" class="form-label"
                            >จำนวนหน่วย
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-quality"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6': validateItem.qty.$error
                            }"
                            v-model.number="validateItem.qty.$model"
                            @keyup="summaryAmount"
                            @change="summaryAmount"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.qty.$error"
                            >{{ validateItem.qty.required.$message }}</span
                          >
                        </div>
                        <!-- ราคาก่อนรวมภาษี -->
                        <div class="">
                          <label for="material-amount" class="form-label"
                            >ราคาก่อนรวมภาษี
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-amount"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6': validateItem.amount.$error
                            }"
                            v-model.number="validateItem.amount.$model"
                            @keyup="calPriceQty"
                            @change="calPriceQty"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.amount.$error"
                            >{{ validateItem.amount.required.$message }}</span
                          >
                        </div>
                        <!-- จำนวนรับที่ไม่ตรงกับหน่วยที่ตั้ง -->
                        <div class="">
                          <label for="material-quality" class="form-label"
                            >จำนวนรับที่ไม่ตรงกับหน่วยที่ตั้ง</label
                          >
                          <input
                            type="number"
                            id="material-quality"
                            class="form-control"
                            min="0"
                            v-model.number="formPOItem.qtyPoDiff"
                          />
                        </div>
                        <!-- เงินประกันผลงาน -->
                        <div class="grid grid-cols-4 gap-4">
                          <!-- เงินประกันผลงาน -->
                          <div class="col-span-2">
                            <label for="material-vat" class="form-label "
                              >เงินประกันผลงาน</label
                            >
                            <input
                              type="number"
                              id="material-vat"
                              class="form-control col-span-3"
                              min="0"
                              v-model.number="formPOItem.retention"
                              @keyup="calRetention"
                              @change="calRetention"
                              :disabled="!formPOItem.retentionProcess"
                            />
                          </div>
                          <!-- percent -->
                          <div>
                            <label for="" class="form-label ">%</label>
                            <input
                              id=""
                              type="number"
                              class="form-control"
                              v-model.number="formPOItem.retentionRate"
                              min="0"
                              max="100"
                              @change="calRetentionProcess"
                            />
                          </div>
                          <div class="flex items-end">
                            <button
                              class="btn"
                              :class="[
                                formPOItem.retentionProcess
                                  ? 'btn-primary'
                                  : 'btn-secondary'
                              ]"
                              @click="
                                ;[
                                  (formPOItem.retentionProcess = !formPOItem.retentionProcess),
                                  calRetentionProcess()
                                ]
                              "
                            >
                              คำนวณ
                            </button>
                          </div>
                        </div>
                        <!-- ภาษีมูลค่าเพิ่ม -->
                        <div class="grid grid-cols-4 gap-4">
                          <!-- ภาษีมูลค่าเพิ่ม -->
                          <div class="col-span-2">
                            <label for="material-vat" class="form-label "
                              >ภาษีมูลค่าเพิ่ม</label
                            >
                            <input
                              type="number"
                              id="material-vat"
                              class="form-control col-span-3"
                              min="0"
                              v-model.number="formPOItem.vat"
                              @keyup="calVat"
                              @change="calVat"
                              :disabled="!formPOItem.taxVatProcess"
                            />
                          </div>
                          <!-- ภาษี -->
                          <div>
                            <label for="material-vat-per" class="form-label "
                              >ภาษี</label
                            >
                            <input
                              id="material-vat-per"
                              type="number"
                              class="form-control"
                              v-model.number="formPOItem.taxVatDefault"
                              min="0"
                              max="100"
                              @change="calVatProcess"
                            />
                          </div>
                          <div class="flex items-end">
                            <button
                              class="btn"
                              :class="[
                                formPOItem.taxVatProcess
                                  ? 'btn-primary'
                                  : 'btn-secondary'
                              ]"
                              @click="
                                ;[
                                  (formPOItem.taxVatProcess = !formPOItem.taxVatProcess),
                                  calVatProcess()
                                ]
                              "
                            >
                              คำนวณ
                            </button>
                          </div>
                        </div>
                        <!-- ภาษีหัก ณ ที่จ่าย -->
                        <div class="grid grid-cols-4 gap-4">
                          <!-- ภาษีหัก ณ ที่จ่าย -->
                          <div class="col-span-2">
                            <label for="material-wh" class="form-label "
                              >ภาษีหัก ณ ที่จ่าย</label
                            >
                            <input
                              type="number"
                              id="material-wh"
                              class="form-control col-span-3"
                              v-model.number="formPOItem.whTax"
                              min="0"
                              @keyup="calTax"
                              @change="calTax"
                              :disabled="!formPOItem.taxWhProcess"
                            />
                          </div>
                          <!-- ภาษี -->
                          <div>
                            <label for="material-vat-per" class="form-label "
                              >หัก</label
                            >
                            <input
                              id="material-vat-per"
                              type="number"
                              class="form-control"
                              v-model.number="formPOItem.whTaxDefault"
                              min="0"
                              max="100"
                              @change="calTaxProcess"
                            />
                          </div>
                          <div class="flex items-end">
                            <button
                              class="btn"
                              :class="[
                                formPOItem.taxWhProcess
                                  ? 'btn-primary'
                                  : 'btn-secondary'
                              ]"
                              @click="
                                ;[
                                  (formPOItem.taxWhProcess = !formPOItem.taxWhProcess),
                                  calTaxProcess()
                                ]
                              "
                            >
                              คำนวณ
                            </button>
                          </div>
                        </div>
                        <!-- Actual Cost -->
                        <div class="grid grid-cols-3 gap-4">
                          <div class="col-span-2">
                            <label for="material-actualCost" class="form-label"
                              >Actual Cost
                              <span class="text-theme-6">*</span></label
                            >
                            <input
                              type="number"
                              id="material-actualCost"
                              class="form-control"
                              min="0"
                              :class="{
                                'border-theme-6': validateItem.actualCost.$error
                              }"
                              v-model.number="validateItem.actualCost.$model"
                            />
                            <span
                              class="text-theme-6"
                              v-if="validateItem.actualCost.$error"
                              >{{
                                validateItem.actualCost.required.$message
                              }}</span
                            >
                          </div>
                          <div class="">
                            <label for="material-vat-per" class="form-label "
                              >แบ่งรับ %</label
                            >
                            <input
                              type="number"
                              id="material-actualCost-percent"
                              class="form-control"
                              min="0"
                              max="100"
                              v-model.number="formPOItem.percent"
                              @keyup="calActualCost"
                              @change="calActualCost"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                <!-- รายละเอียดงบประมาณ -->
                <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">รายละเอียดงบประมาณ</div>
                  <div class="">
                    <div class="mb-4 space-y-4">
                      <!-- ปีงบประมาณ -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">ปีงบประมาณ: </label>
                        <div>{{ formPOItem.budgetInfo.year }}</div>
                      </div>
                      <!-- รหัส BU -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">รหัส BU:</label>
                        <div>{{ formPOItem.budgetInfo.bu_code }}</div>
                      </div>
                      <!-- ชนิดงบประมาณ -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">ชนิดงบประมาณ:</label>
                        <div>{{ formPOItem.budgetInfo.bu_type }}</div>
                      </div>
                      <!-- ใช้งบประมาณของหน่วยงาน -->
                      <div
                        v-if="formPOItem.budgetInfo.subledger"
                        class="flex justify-between"
                      >
                        <label for="" class="font-bold"
                          >ใช้งบประมาณของโครงการ:</label
                        >
                        <div>{{ formPOItem.budgetInfo.subledger_name }}</div>
                      </div>
                      <div v-else class="flex justify-between">
                        <label for="" class="font-bold"
                          >ใช้งบประมาณของหน่วยงาน:</label
                        >
                        <div>{{ formPOItem.budgetInfo.bu_name }}</div>
                      </div>
                      <!-- Account Code -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Account Code:</label>
                        <div>{{ formPOItem.budgetInfo.account_code }}</div>
                      </div>
                      <!-- Subsidiary -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Subsidiary:</label>
                        <div>{{ formPOItem.budgetInfo.subsidiary }}</div>
                      </div>
                      <!-- Account Name -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Account Name:</label>
                        <div>{{ formPOItem.budgetInfo.account_name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- รายละเอียดด้านบัญชี -->
                <!-- <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">รายละเอียดภาษี</div>
                  <div class="">
                    <div class="mb-4 space-y-4">
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Tax Rate: </label>
                        <div>{{ getTaxRate(formPOItem.taxRate) }}</div>
                      </div>
                      <div class="flex justify-between">
                        <label for="" class="font-bold">GL Offset:</label>
                        <div>
                          {{
                            formPOItem.glOffset
                              ? formPOItem.glOffset
                              : 'ไม่ระบุ'
                          }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Cat Code:</label>
                        <div>{{ getCatCode(formPOItem.catCode) }}</div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
              <div>
                <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">ประวัติการ GR</div>
                  <div class="">
                    <table class="table table--sm">
                      <thead>
                        <tr class="bg-gray-700 text-white">
                          <th class="whitespace-nowrap text-center" width="3%">
                            ลำดับ
                          </th>
                          <th class="whitespace-nowrap text-center" width="13%">
                            เลขที่ GR
                          </th>
                          <th class="whitespace-nowrap text-center" width="41%">
                            รายละเอียด
                          </th>
                          <th class="whitespace-nowrap text-center" width="5%">
                            จำนวนที่รับ
                          </th>
                          <th class="whitespace-nowrap text-center" width="10%">
                            หน่วยนับ
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            รวม
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            หัก ณ ที่จ่าย
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            Vat
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            Actual Cost
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="text-center"
                          v-if="remain.history.length == 0"
                        >
                          <td colspan="9" class="border-b">ไม่พบรายการ</td>
                        </tr>
                        <tr
                          v-for="(rHistory, index) in remain.history"
                          :key="index"
                        >
                          <td class="text-center border-b-2">
                            {{ index + 1 }}.
                          </td>
                          <td class=" border-b-2">{{ rHistory.gr_no_full }}</td>
                          <td class="border-b-2">{{ rHistory.item_name }}</td>
                          <td class="text-right border-b-2">
                            {{ rHistory.qty }}
                          </td>
                          <td class="text-center border-b-2">
                            {{ rHistory.uom }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.amount) }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.wh_tax) }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.vat) }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.actual_cost) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- btn save and cancal -->
              <div class="mt-4 flex">
                <button
                  type="button"
                  class="btn btn-primary disabled:opacity-50 mr-2 flex items-center"
                  @click.prevent="updateItem()"
                  :disabled="btnItemSave.disabled"
                  v-show="!btnItemSave.hide"
                >
                  <FileTextIcon
                    class="w-4 h-4 mr-2"
                    v-if="!btnItemSave.loading"
                  />
                  <LoadingIcon
                    icon="oval"
                    color="blue"
                    v-else
                    class="w-4 h-4 mr-2"
                  />
                  Save
                </button>
                <button class="btn ml-2" @click="clearFormItem()">
                  <Trash2Icon class="w-4 h-4 mr-2" />Cancel
                </button>
              </div>

              <!-- modal table -->
              <div
                id="modal-material"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableMaterial
                        v-model="formPOItem.materialSelected"
                        :materialGroup="orderTypeOptions"
                        :order-type="formPO.orderTypeSelected"
                        @setMaterial="setMaterial"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- รายการเบิก -->
          <div class="grid grid-cols-1 mt-5">
            <div class="box p-5">
              <div class="md:flex md:justify-between pb-4">
                <div class="flex">
                  <div class="text-lg font-bold">รายการสินค้า</div>
                  <OverBudget />
                </div>
                <div class="text-right mt-2 md:mt-0">
                  <button
                    class="btn btn-outline-primary ml-2"
                    type="button"
                    @click.stop="checkBudget()"
                  >
                    <CheckCircleIcon class="w-4 h-4 mr-2 hidden md:block" />
                    ตรวจสอบงบประมาณ
                  </button>
                </div>
              </div>
              <!-- table -->
              <div class="overflow-x-scroll">
                <table class="table table--sm">
                  <thead>
                    <tr class="bg-gray-700 text-white">
                      <th class="whitespace-nowrap text-center" width="3%">
                        ลำดับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="40%">
                        รายละเอียดสินค้า
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ราคาต่อหน่วย<br />(ไม่รวมภาษี)
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จำนวนสินค้า
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        หน่วยนับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ราคา<br />ก่อนรวมภาษี
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ภาษี<br />มูลค่าเพิ่ม
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        หัก ณ ที่จ่าย
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ประกันผลงาน
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        รวมเป็นเงิน<br />ทั้งหมด
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จัดการ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center" v-if="items.length == 0">
                      <td colspan="10" class="border-b">ไม่พบรายการ</td>
                    </tr>
                    <tr
                      v-for="(item, inx) in items"
                      :key="item.pr_item_id"
                      v-else
                    >
                      <td class="border-b-2 text-center">{{ inx + 1 }}.</td>
                      <td
                        class="border-b-2"
                        v-html="
                          item.item_name
                            ? item.item_name.replaceAll('\n', '<br/>')
                            : ''
                        "
                      ></td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.unit_price) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.qty) }}
                      </td>
                      <td class="text-center border-b-2">{{ item.uom }}</td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.amount) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.vat) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.wh_tax) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.retention) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.actual_cost) }}
                      </td>
                      <td class="text-right border-b-2">
                        <div>
                          <button
                            class="btn btn-sm"
                            :class="[
                              item.is_edit
                                ? 'btn-warning'
                                : 'btn-outline-warning'
                            ]"
                            @click="getPOItem(item.po_item_id, inx)"
                          >
                            <EditIcon class="w-4 h-4" />
                          </button>
                          <a
                            href="javascript:;"
                            class="btn btn-sm btn-danger ml-2"
                            data-toggle="modal"
                            data-target="#delete-pv-item-modal-preview"
                            @click="setDeleteGRItem(item.po_item_id)"
                            v-show="!formGR.grEdit"
                          >
                            <Trash2Icon class="w-4 h-4" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ประเภทของงบประมาณ -->
          <div class="grid lg:grid-cols-2 gap-0 lg:gap-4">
            <div class="mt-5">
              <TableSummaryCost :items="formPO.itemSummary" />
            </div>
            <div class="mt-5" v-if="formPO.poEdit">
              <TableHistory :items="formPO.historyArray" />
            </div>
          </div>

          <!-- BEGIN: Modal Content -->
          <div
            id="delete-pv-item-modal-preview"
            class="modal"
            tabindex="-1"
            data-backdrop="static"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
                    <div class="text-3xl mt-5">คุณแน่ใจ</div>
                    <div class="text-gray-600 mt-2">
                      ต้องการลบรายการนี้ ใช่ หรือ ไม่?
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
                      @click="cancelDeleteGRItem()"
                    >
                      ไม่
                    </button>
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-danger w-24"
                      @click="confirmDeleteGRItem()"
                    >
                      ใช่
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Modal Content -->
          <!-- BEGIN: Modal Content -->
          <ModalCancel
            module="procurement"
            doc-type="gr"
            :doc-id="formGR.grID"
            redirect-complete="procurementGRWait"
          />
          <!-- END: Modal Content -->
        </div>
        <!-- BEGIN: Modal PR -->
        <div
          id="modal-po-list"
          class="modal"
          tabindex="-1"
          data-backdrop="static"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-body p-10 text-center">
                <TableListSelectedPO
                  title="PO list"
                  :data="poList"
                  :hasOption="true"
                  :fieldOptions="{
                    label: 'doc_no_full,vendor_name',
                    value: 'po_id'
                  }"
                  :btnConfirm="true"
                  :btnClosed="true"
                  :mainSelected="poChosen"
                  :itemsSelected="items"
                  :displayStatus="modalPODisplay"
                  @confirm="confirmPO"
                  @closed="closedModalPOList"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- END: Modal PR -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  onUnmounted,
  onMounted,
  ref,
  toRefs,
  watch
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api } from '@/utils/api'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import alert from '@/helpers/alert'
import helpers from '@/helpers'

import OverBudget from '@/components/overBudget.vue'
import WfSelectSingleEmployee from '@/components/select-single-employee/Main.vue'
import TableMaterial from '@/components/table-material/Main.vue'
import TableListSelectedPO from '@/components/table-list-selected/Po.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import AttachFileUpload from '@/components/attach-file/Upload.vue'
import DetailShipping from '@/components/DetailShipping.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import ModalCancel from '@/components/ModalCancel.vue'
import TextEditor from '@/components/TextEditor.vue'
// import WfSelectSingleVendor from '@/components/select-single-vendor/Main.vue'

export default {
  components: {
    OverBudget,
    WfSelectSingleEmployee,
    TableMaterial,
    TableSummaryCost,
    AttachFilePreview,
    AttachFileUpload,
    TableHistory,
    TableListSelectedPO,
    DetailShipping,
    DocumentPath,
    ModalCancel,
    TextEditor
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const documentPath = computed(() => store.state.gr.documentPath)
    const btnCancel = computed(() => store.state.gr.btnCancel)
    const btnSave = computed(() => store.state.gr.btnSave)
    const btnDraft = computed(() => store.state.gr.btnDraft)
    const btnReject = computed(() => store.state.gr.btnReject)
    const btnItemSave = computed(() => store.state.gr.btnItemSave)
    const instalmentOptions = computed(() => store.state.gr.grInstalmentType)
    const instalmentNo = computed(() => store.state.gr.grInstalmentNo)
    const instalmentDefault = computed(
      () => store.state.gr.grInstalmentTypeDefault
    )
    const userInfo = computed(() => store.state.auth.info)

    const companyOptions = computed(() => store.state.global.company)
    const companyDefault = computed(() => store.state.global.companyDefault)
    const employeeDefault = computed(() => store.state.global.employeeDefault)
    // const cashOptions = computed(() => store.state.global.cash)
    // const memoOptions = computed(() => store.state.gr.memo)
    const orderTypeOptions = computed(() => store.state.gr.orderType)
    const poList = computed(() => store.state.gr.poList)
    const poChosen = ref(null)
    const docNoFull = ref(null)
    const itemIndex = ref(null)
    const remain = reactive({
      sumActualCost: 0,
      instalmentLatest: 0,
      remainActualCost: 0,
      history: []
    })
    // const shippingRecipientOption = computed(
    //   () => store.state.po.shippingRecipientOption
    // )
    // const shippingConditionPaymentOption = computed(
    //   () => store.state.po.shippingConditionPaymentOption
    // )
    const { numberFormat, numberFormat2, dateFormat, fillBorderColor } = helpers
    const fileUploadMaxSize = computed(
      () => store.state.global.fileUploadMaxSize
    )
    // const resValidator = ref(null)

    const uomOptions = computed(() => store.getters['global/getUOMOptions'])
    // const documentSpacialPathOptions = computed(
    //   () => store.state.global.documentSpacialPath
    // )
    const isLoadingGRList = ref(false)
    const files = ref([])

    const documentPathText = computed(() => store.state.gr.documentPathText)

    // const rulesPO = {
    //   shippingAddress: { required },
    //   shippingRecipient: { required },
    //   shippingConditionSendSelected: { required },
    //   shippingConditionPaymentSelected: { required },
    //   shippingCheckBy: { required },
    //   shippingDate: { required }
    // }

    const formPO = reactive({
      currencyCode: '',
      memoSelected: null,
      // ememoId: '',
      // ememoTitle: '',
      // ememoLink: '',
      ememo: {
        id: null,
        title: null,
        link: null
      },
      detail: '',
      orderTypeText: '',
      itemSummary: [],
      historyArray: [],
      statusCode: null,
      docNoFull: '',
      prDocNoFull: '',

      vendorSelectedEdit: null,
      vendorCodeEdit: '',
      vendorNameEdit: '',
      vendorAddressEdit: '',
      vendorSelected: null,
      vendorCode: '',
      vendorName: '',
      vendorAddress: '',
      vendorEmail: '',
      vendorTelephone: '',
      reasonChosenVendor: '',
      poDocTypeText: '',
      discountAllItem: null,

      // shippingAddress: '',
      // shippingRecipient: '',
      // shippingConditionSend: null,
      // shippingConditionPayment: null,
      // shippingCheckBy: '',
      // shippingDate: '',
      shipping: {
        date: '',
        address: '',
        recipient: '',
        conditionSend: '',
        conditionPayment: '',
        checkBy: ''
      },
      orderTypeSelected: null,
      importantFactor: ''
    })

    const formGR = reactive({
      grID: route.params.id || null,
      isEdit: route.params.id || null,
      grEdit: route.params.id !== undefined,
      companySelected: store.state.auth.info.comp_no,
      telephone: store.state.global.employeeDefault.telephone,
      employeeSelected: store.state.auth.info.employeeId,
      invoiceNo: '',
      invoiceDate: '',
      instalmentType: instalmentDefault.value,
      instalmentNo: 1,
      specialPath: null,
      documentPath: [],
      glDate: '',
      reqDetail: '',
      reqName: '',
      reqId: '',
      reqDate: '',
      poId: null,
      docNoFull: '',
      approveResultArray: [],
      documentPathArray: [],
      nextStatus: '',
      statusCode: null
    })

    const rulesGR = {
      invoiceNo: { required },
      invoiceDate: { required },
      reqDate: { required },
      reqDetail: { required },
      telephone: { required }
    }

    const validateGR = useVuelidate(rulesGR, toRefs(formGR))

    watch([instalmentDefault, instalmentNo], newVal => {
      // console.log('watch instalmentDefault: ', newVal)
      formGR.instalmentType = newVal[0]
      formGR.instalmentNo = newVal[1]
      if (newVal[0] != 'm') {
        formGR.instalmentNo = 1
      }
    })

    watch(
      () => formGR.instalmentType,
      newVal => {
        // console.log('watch instalmentType: ', newVal)
        store.commit('gr/setGrInstalmentTypeDefault', newVal)
        if (newVal == 'm') {
          store.dispatch('gr/loadGrOptionInstalmentNo', {
            poId: formGR.poId,
            grId: formGR.grID
          })
        }
      }
    )

    watch(
      () => store.state.po.orderTypeDefault,
      () => {
        formPO.orderTypeSelected = store.state.po.orderTypeDefault
      }
    )

    const setPO = data => {
      formPO.vendorCode = data.vendor_code
      formPO.vendorName = data.vendor_name
      formPO.vendorAddress = data.vendor_address
      formPO.vendorTelephone = data.vendor_telephone
      formPO.vendorEmail = data.vendor_email
      formPO.poDocTypeText = data.po_doc_type_text
      formPO.reasonChosenVendor = data.reason_chosen_vendor
      formPO.currencyCode = data.currency_code
      formPO.orderTypeText = data.order_type_text
      formPO.memoSelected = data.ememo_id
      formPO.detail = data.req_detail

      formPO.shipping.address = data.shipping_address
      formPO.shipping.recipient = data.shipping_recipient
      formPO.shipping.conditionSend = data.shipping_condition_label
      formPO.shipping.conditionPayment = data.payment_term_name
      formPO.shipping.checkBy = data.shipping_check_by
      formPO.shipping.date = data.shipping_date

      if (data.ememo_id != 0 && data.ememo_id != null) {
        formPO.ememo.id = data.ememo_id
        formPO.ememo.title = data.ememo_title
        formPO.ememo.link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${data.ememo_id}/detail`
      }

      formPO.docNoFull = data.doc_no_full
      formPO.prDocNoFull = data.pr_doc_no_full
      formPO.importantFactor = data.important_factor
      files.value = data.file_attach_array

      formGR.poId = data.po_id
    }

    const items = ref([])
    const modalPODisplay = ref('hide')
    const openModalPOList = () => {
      modalPODisplay.value = 'open'
    }
    const closedModalPOList = () => {
      modalPODisplay.value = 'hide'
    }

    const confirmPO = data => {
      // console.log('data: ', data.chosen.value !== null, data)
      if (data.chosen.value !== null) {
        isLoadingGRList.value = true
        setPO(data.chosen)
        docNoFull.value = data.chosen.doc_no_full
        // items.value = data.chosenItems
        items.value = data.chosenItems.map(v => {
          return {
            ...v,
            retention: v.retention || 0,
            retention_rate: v.retention_rate || 5,
            // retention_process: true
            retention_process:
              v.retention != undefined
                ? !!(v.retention > 0 || v.retention_rate > 0)
                : false
          }
        })

        // console.log('items: ', items.value, data.chosenItems)
        poChosen.value = data.chosen
        if (!formGR.grEdit) {
          store.dispatch('gr/loadDocumentPath', {
            compNo: companyDefault.value.comp_no,
            employeeId: formGR.employeeSelected,
            pr_id: data.chosen.pr_id
          })
        }
      } else {
        isLoadingGRList.value = false
      }
    }

    // const specialPathSelected = ref(null)
    // watch(specialPathSelected, newVal => {
    //   store.dispatch('gr/loadDocumentPath', {
    //     compNo: companyDefault.value.comp_no,
    //     employeeId: formGR.employeeSelected,
    //     specialPath: newVal
    //   })
    // })

    const boxItemOpen = ref(false)
    const toggleBoxItemOpen = () => {
      clearFormItem()
      boxItemOpen.value = !boxItemOpen.value
    }

    const deletePOItemID = ref(null)
    const setDeleteGRItem = id => {
      deletePOItemID.value = id
    }
    const cancelDeleteGRItem = () => {
      deletePOItemID.value = null
    }
    const confirmDeleteGRItem = async () => {
      const delItems = items.value.find(
        item => item.po_item_id === deletePOItemID.value
      )
      if (delItems) {
        if (delItems.gr_item_id) {
          await api
            .delete(`/procurement/gr/deleteItem/${delItems.gr_item_id}`)
            .then(res => {
              if (res.code == 200) {
                items.value.map(item => {
                  if (item.po_item_id === deletePOItemID.value) {
                    item.gr_item_id = null
                  }
                  return item
                })
                const newItems = items.value.filter(
                  item => item.po_item_id !== deletePOItemID.value
                )
                items.value = newItems
                deletePOItemID.value = null
                alert.success()
              } else {
                alert.error(res.message)
              }
            })
            .catch(e => {
              alert.error(e.message)
            })
        } else {
          const newItems = items.value.filter(
            item => item.po_item_id !== deletePOItemID.value
          )
          items.value = newItems
          deletePOItemID.value = null
          alert.success()
        }
      } else {
        alert.error('ไม่พบข้อมูล')
      }
    }

    const formPOItem = reactive({
      prItemID: null,
      poItemID: null,
      budgetSelected: null,
      materialSelected: null,
      budgetInfo: {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      },
      budgetSubledgerSelected: null,
      bu_year: null,
      bu_name: null,
      uom: null,
      uomSelected: null,
      useDate: '',
      pickupLoc: '',
      amount: 0,
      qty: 0,
      actualCost: 0,
      actualCostTmp: 0,
      vat: 0,
      taxVatDefault: 7,
      taxVatProcess: true,
      whTaxDefault: 3,
      whTax: 0,
      taxWhProcess: false,
      materialInfo: {
        account_code: null,
        all_unit: null,
        base_unit: null,
        business_unit_code: null,
        description: '',
        description_code: '',
        gl_category: '',
        it_item: null,
        material_code: '',
        material_group: '',
        material_type: '',
        order_unit: '',
        plant: null,
        power_unit_no: null,
        price: null,
        primary_unit: '',
        purchase_group: null,
        secondary_unit: '',
        storage_location: null,
        subsidiary: null,
        update_date: null
      },
      taxRate: null,
      glOffset: null,
      catCode: null,
      bargainDiscount: '',
      usePriceType: 'po',
      qtyPoDiff: 0,
      percent: 0,
      retention: 0,
      retentionRate: 5,
      retentionProcess: false
    })

    const summaryAmount = () => {
      if (formPOItem.materialInfo.price > 0) {
        // formPOItem.amount + formPOItem.vat - formPOItem.whTax
        formPOItem.amount = parseFloat(
          numberFormat2(formPOItem.materialInfo.price * formPOItem.qty)
        )
      } else {
        formPOItem.amount = 0
      }
      calPriceQty()
    }

    const calPriceQty = () => {
      // if (formPOItem.materialInfo.price > 0) {
      // formPOItem.amount = formPOItem.materialInfo.price * formPOItem.qty
      calVatProcess()
      calTaxProcess()
      calRetentionProcess()
      // }
    }

    const calRetention = () => {
      formPOItem.actualCost = numberFormat2(
        formPOItem.amount +
          formPOItem.vat -
          formPOItem.whTax -
          formPOItem.retention
      )
      calActualCost()
    }

    const calVat = () => {
      formPOItem.actualCost = numberFormat2(
        formPOItem.amount + formPOItem.vat - formPOItem.whTax
      )
      calActualCost()
    }

    const calTax = () => {
      formPOItem.actualCost = numberFormat2(
        formPOItem.amount + formPOItem.vat - formPOItem.whTax
      )
      calActualCost()
    }

    const calRetentionProcess = () => {
      if (formPOItem.retentionProcess) {
        if (formPOItem.retentionRate > 0 && formPOItem.retentionRate <= 100) {
          formPOItem.retention =
            (formPOItem.amount * formPOItem.retentionRate) / 100
        } else {
          formPOItem.retention = 0
        }
      } else {
        formPOItem.retention = 0
      }
      calRetention()
    }

    const calVatProcess = () => {
      if (formPOItem.taxVatProcess) {
        if (formPOItem.taxVatDefault > 0 && formPOItem.taxVatDefault <= 100) {
          formPOItem.vat = (formPOItem.amount * formPOItem.taxVatDefault) / 100
        } else {
          formPOItem.vat = 0
        }
      } else {
        formPOItem.vat = 0
      }
      calVat()
    }

    const calTaxProcess = () => {
      if (formPOItem.taxWhProcess) {
        if (formPOItem.whTaxDefault > 0 && formPOItem.whTaxDefault <= 100) {
          formPOItem.whTax = (formPOItem.amount * formPOItem.whTaxDefault) / 100
        } else {
          formPOItem.whTax = 0
        }
      } else {
        formPOItem.whTax = 0
      }
      calTax()
    }

    const calActualCost = () => {
      // console.log('percent: ', formPOItem.percent)
      formPOItem.actualCostTmp =
        formPOItem.amount + formPOItem.vat - formPOItem.whTax
      if (formPOItem.percent > 0 && formPOItem.percent <= 100) {
        formPOItem.actualCost = numberFormat2(
          (formPOItem.actualCostTmp * formPOItem.percent) / 100
        )
        // } else {
        //   formPOItem.actualCost = formPOItem.actualCostTmp
      }
    }

    const rulesItem = {
      materialInfo: {
        description: { required },
        price: { required }
      },
      pickupLoc: { required },
      qty: { required },
      amount: { required },
      uomSelected: { required },
      useDate: { required },
      actualCost: { required }
    }

    const validateItem = useVuelidate(rulesItem, toRefs(formPOItem))

    const setBudget = val => {
      formPOItem.budgetInfo.year = val.year
      formPOItem.budgetInfo.bu_code = val.bu_code
      formPOItem.budgetInfo.bu_name = val.bu_name
      formPOItem.budgetInfo.subsidiary = val.subsidiary
      formPOItem.budgetInfo.subledger = val.subledger
      formPOItem.budgetInfo.account_code = val.account_code
      formPOItem.budgetInfo.account_name = val.account_name
      formPOItem.budgetInfo.subledger_name = val.subledger_name
      formPOItem.budgetInfo.bu_type = val.subledger
        ? 'งบประมาณโครงการ'
        : 'งบประมาณหน่วยงาน'
    }

    const setMaterial = val => {
      formPOItem.materialInfo.account_code = val.account_code
      formPOItem.materialInfo.all_unit = val.all_unit
      formPOItem.materialInfo.base_unit = val.base_unit
      formPOItem.materialInfo.business_unit_code = val.business_unit_code
      formPOItem.materialInfo.description = val.description
      formPOItem.materialInfo.description_code = val.description_code
      formPOItem.materialInfo.gl_category = val.gl_category
      formPOItem.materialInfo.it_item = val.it_item
      formPOItem.materialInfo.material_code = val.material_code
      formPOItem.materialInfo.material_group = val.material_group
      formPOItem.materialInfo.material_type = val.material_type
      formPOItem.materialInfo.order_unit = val.order_unit
      formPOItem.materialInfo.plant = val.plant
      formPOItem.materialInfo.power_unit_no = val.power_unit_no
      formPOItem.materialInfo.price = val.price
      formPOItem.materialInfo.primary_unit = val.primary_unit
      formPOItem.materialInfo.purchase_group = val.purchase_group
      formPOItem.materialInfo.secondary_unit = val.secondary_unit
      formPOItem.materialInfo.storage_location = val.storage_location
      formPOItem.materialInfo.subsidiary = val.subsidiary
      formPOItem.materialInfo.update_date = val.update_date
    }

    // const companyChange = () => {
    //   store.commit('global/setCompanyDefault', { no: formGR.companySelected })
    // }

    watch(
      () => formPO.vendorSelected,
      newVal => {
        // console.log('watch: ', newVal)
        if (newVal) {
          if (formPO.poEdit) {
            if (newVal.vendor_code == formPO.vendorSelectedEdit) {
              formPO.vendorName = formPO.vendorNameEdit
              formPO.vendorCode = formPO.vendorCodeEdit
              formPO.vendorAddress = formPO.vendorAddressEdit
            } else {
              formPO.vendorName = newVal.vendor_name
              formPO.vendorCode = newVal.vendor_code
              formPO.vendorAddress = newVal.vendor_address
            }
          } else {
            formPO.vendorName = newVal.vendor_name
            formPO.vendorCode = newVal.vendor_code
            formPO.vendorAddress = newVal.vendor_address
          }
        }
      }
    )

    // watch([companyDefault, () => formGR.employeeSelected], (newVal, oldVal) => {
    //   console.log('poChosen: ', poChosen.value !== null, poChosen)
    //   if (newVal[0] != oldVal[0]) {
    //     // store.dispatch('global/loadDocumentSpacialPath', {
    //     //   compNo: companyDefault.value.comp_no
    //     // })
    //     store.dispatch('gr/loadDocumentPath', {
    //       compNo: companyDefault.value.comp_no,
    //       employeeId: formGR.employeeSelected,
    //       // specialPath: null
    //       pr_id: poChosen.value !== null ? poChosen.value.pr_id : null
    //       // specialPath: specialPathSelected.value
    //     })
    //   }
    //   // specialPathSelected.value = null

    //   if (newVal[1] != oldVal[1]) {
    //     store.dispatch('gr/loadDocumentPath', {
    //       compNo: companyDefault.value.comp_no,
    //       employeeId: formGR.employeeSelected,
    //       // specialPath: null
    //       pr_id: poChosen.value !== null ? poChosen.value.pr_id : null
    //     })
    //   }
    //   store.dispatch('gr/loadPOList', {
    //     employeeId: formGR.employeeSelected,
    //     company: formGR.companySelected
    //   })
    // })

    const onChangeDocumentPath = async data => {
      // console.log('e: ', data)
      // if (data.target == 'select-company') {
      //   store.commit('global/setCompanyDefault', { no: formPV.companySelected })
      // }
      // if (
      //   data.target == 'select-single-employee' ||
      //   data.target == 'select-company'
      // ) {
      //   // loading special path option
      //   await store.dispatch('global/loadDocumentSpacialPath', {
      //     compNo: companyDefault.value.comp_no
      //   })
      //   specialPathSelected.value = null
      // }
      // await store.dispatch('gr/loadDocumentPath', {
      //   compNo: companyDefault.value.comp_no,
      //   employeeId: formGR.employeeSelected,
      //   pr_id: poChosen.value !== null ? poChosen.value.pr_id : null
      // })

      items.value = []
      poChosen.value = null
      docNoFull.value = ''
      isLoadingGRList.value = false

      store.commit('gr/setDocumentPath', null)
      store.commit('gr/setDocumentPathText', null)

      if (data.target == 'select-company' || data.target == 'mounted') {
        // console.log('formGR.companySelected: ', formGR.companySelected)
        store.commit('global/setCompanyDefault', { no: formGR.companySelected })
      }

      store.dispatch('gr/loadPOList', {
        employeeId: formGR.employeeSelected,
        company: formGR.companySelected
      })
      formGR.telephone = store.state.global.employeeDefault.telephone
    }
    watch(
      () => employeeDefault.value,
      newVal => {
        formGR.telephone = newVal.telephone
      }
    )

    const saveGR = async isDraft => {
      // disabled and loading
      validateGR.value.$touch()
      if (!validateGR.value.$invalid) {
        if (isDraft) {
          store.commit('gr/setBtnActiveFix', { type: 'btnDraft', status: true })
        } else {
          store.commit('gr/setBtnActiveFix', { type: 'btnSave', status: true })
        }
        validateGR.value.$reset()

        const dataGR = {
          is_draft: isDraft,
          username: userInfo.value.fullname,
          employee_id: userInfo.value.employeeId,
          gr_comp: formGR.companySelected,
          telephone: formGR.telephone,
          po_id: formGR.poId,
          req_date: dateFormat(formGR.reqDate),
          req_id: employeeDefault.value.employee_id,
          req_name: employeeDefault.value.fullname_th,
          req_detail: fillBorderColor(formGR.reqDetail),
          owner_id: userInfo.value.employeeId,
          owner_name: userInfo.value.fullname,
          invoice_no: formGR.invoiceNo,
          invoice_date: dateFormat(formGR.invoiceDate),
          instalment_type: formGR.instalmentType,
          instalment_no: formGR.instalmentNo,
          // special_path: specialPathSelected.value,
          gl_date: dateFormat(formGR.glDate),
          file_attach: await store.getters['gr/getFileAttach'],
          document_path: documentPath.value
        }

        if (!formGR.grEdit) {
          await api
            .post('/procurement/gr/insert', dataGR)
            .then(async res => {
              if (res.code == 200) {
                formGR.grID = res.data.gr_id
                formGR.grEdit = true
                await saveItem()
                // alertBudget(false, res.data.is_over_budget)
                alert.success()
                store.commit('gr/setBtnDisplay', {
                  key: 'btnCancel',
                  status: true
                })
                store.commit('gr/setBtnDisplay', {
                  key: 'btnSave',
                  status: true
                })
              } else {
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
                alert.error(res.message)
                return
              }
              if (isDraft) {
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                router.push({
                  name: 'procurementGRFormDetail',
                  params: { id: res.data.gr_id }
                })
              }
            })
            .catch(e => {
              alert.error(e.message)
              if (isDraft) {
                store.commit('po/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                store.commit('po/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
              }
            })
        } else {
          await api
            .put(`/procurement/gr/update/${formGR.grID}`, dataGR)
            .then(async res => {
              if (res.code == 200) {
                alert.success()
              } else {
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
                alert.error(res.message)
                return
              }
              if (isDraft) {
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                router.push({
                  name: 'procurementGRFormDetail',
                  params: { id: formGR.grID }
                })
              }
            })
            .catch(e => {
              alert.error(e.message)
              if (isDraft) {
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                store.commit('gr/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
              }
            })
        }
      } else {
        alert.error()
      }
    }

    const clearFormItem = () => {
      // validateItem.value.$reset()
      boxItemOpen.value = false
      // if (formPOItem.poItemID !== null) {
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      // }
      formPOItem.poItemID = null
      formPOItem.prItemID = null
      formPOItem.budgetSelected = null
      formPOItem.materialSelected = null

      formPOItem.budgetInfo = {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      }
      formPOItem.useDate = ''
      formPOItem.pickupLoc = ''
      formPOItem.budgetSubledgerSelected = null
      formPOItem.bu_year = null
      formPOItem.bu_name = null
      formPOItem.uom = null
      formPOItem.uomSelected = null
      formPOItem.amount = 0
      formPOItem.vat = 0
      formPOItem.actualCost = 0
      formPOItem.actualCostTmp = 0
      formPOItem.taxVatDefault = 7
      formPOItem.materialInfo = {
        account_code: null,
        all_unit: null,
        base_unit: null,
        business_unit_code: null,
        description: '',
        description_code: '',
        gl_category: '',
        it_item: null,
        material_code: '',
        material_group: '',
        material_type: '',
        order_unit: '',
        plant: null,
        power_unit_no: null,
        price: null,
        primary_unit: '',
        purchase_group: null,
        secondary_unit: '',
        storage_location: null,
        subsidiary: null,
        update_date: null
      }
      formPOItem.taxRate = null
      formPOItem.glOffset = null
      formPOItem.catCode = null
      formPOItem.bargainDiscount = ''
      formPOItem.usePriceType = 'po'
      formPOItem.qtyPoDiff = 0
      formPOItem.taxVatProcess = true
      formPOItem.whTaxDefault = 3
      formPOItem.whTax = 0
      formPOItem.taxWhProcess = false
      formPOItem.retention = 0
      formPOItem.retentionRate = 5
      formPOItem.retentionProcess = false

      remain.sumActualCost = 0
      remain.instalmentLatest = 0
      remain.remainActualCost = 0
      remain.history = []
    }

    const setDataItem = i => {
      return {
        gr_id: formGR.grID,
        po_item_id: items.value[i].po_item_id,
        use_price_type: items.value[i].use_price_type,
        pickup_loc: items.value[i].pickup_loc,
        use_date: items.value[i].use_date,
        unit_price: items.value[i].unit_price,
        qty: items.value[i].qty,
        amount: items.value[i].amount,
        vat_rate: items.value[i].vat_rate,
        vat: items.value[i].vat,
        wh_tax_rate: items.value[i].wh_tax_rate,
        wh_tax: items.value[i].wh_tax,
        actual_cost: items.value[i].actual_cost,
        qty_po_diff: items.value[i].qty_po_diff,
        uom: items.value[i].uom,
        uom_code: items.value[i].uom_code,
        retention: items.value[i].retention,
        retention_rate: items.value[i].retention_rate

        // item_type: items.value[i].item_type,
        // item_name: items.value[i].item_name,
        // item_code: items.value[i].item_code,
        // item_no: items.value[i].item_no,
        // item_category: items.value[i].item_category,

        // budget_bu_code: items.value[i].budget_bu_code,
        // budget_bu_name: items.value[i].budget_bu_name,
        // budget_bu_req_code: items.value[i].budget_bu_req_code,
        // budget_bu_req_name: items.value[i].budget_bu_req_name,
        // budget_group_code: items.value[i].budget_group_code,
        // budget_group_name: items.value[i].budget_group_name,
        // budget_subledger: items.value[i].budget_subledger,
        // budget_subledger_name: items.value[i].budget_subledger_name,
        // budget_subsidiary: items.value[i].budget_subsidiary,
        // budget_type: items.value[i].budget_type,
        // budget_name: items.value[i].budget_name,
        // budget_code: items.value[i].budget_code,
        // budget_year: items.value[i].budget_year,
        // tax_rate: items.value[i].tax_rate,
        // gl_offset: items.value[i].gl_offset,
        // cat_code: items.value[i].cat_code,
        // bargain_discount: items.value[i].bargain_discount
        // wh_tax: items.value[i].wh_tax,
        // wh_tax_rate: items.value[i].wh_tax_rate
      }
    }

    const saveItem = async () => {
      // const hasError = ref(false)
      let recheckBudget = false
      for (const i in items.value) {
        const data = await setDataItem(i)
        if (items.value[i].gr_item_id === null) {
          await api
            .post('/procurement/gr/insertItem', data)
            .then(async res => {
              if (res.code == 200) {
                alert.success()
                items.value[i].gr_item_id = res.data.gr_item_id
                recheckBudget = true
                // await checkBudget()
              } else {
                // hasError.value = true
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error('รายการที่ ' + (i + 1) + e.message)
              // console.log('e: ', e.message)
              // hasError.value = true
            })
        } else {
          await api
            .put(
              `/procurement/gr/updateItem/${items.value[i].gr_item_id}`,
              data
            )
            .then(async res => {
              if (res.code == 200) {
                alert.success()
                recheckBudget = true
                // await checkBudget()
                // items.value[i].gr_item_id = res.data.gr_item_id
              } else {
                // hasError.value = true
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error('รายการที่ ' + (i + 1) + e.message)
              // console.log('e: ', e.message)
              // hasError.value = true
            })
        }
      }
      if (recheckBudget) {
        await checkBudget()
        await getGRItemSummary()
      }
      // if (hasError.value) {
      //   alert.error('มีบ้างรายการไม่สามารถบันทึกได้')
      //   hasError.value = false
      // }
    }

    const updateItem = async () => {
      validateItem.value.$touch()
      if (!validateItem.value.$invalid) {
        const uom = await store.getters['global/getUOMbyOne'](
          formPOItem.uomSelected
        )
        items.value[itemIndex.value].pr_item_id = formPOItem.prItemID
        items.value[itemIndex.value].po_item_id = formPOItem.poItemID
        items.value[itemIndex.value].budget_year = formPOItem.budgetInfo.year
        items.value[itemIndex.value].budget_bu_name =
          formPOItem.budgetInfo.bu_name
        items.value[itemIndex.value].budget_bu_code =
          formPOItem.budgetInfo.bu_code
        items.value[itemIndex.value].budget_subsidiary =
          formPOItem.budgetInfo.subledger !== ''
            ? formPOItem.budgetInfo.subsidiary
            : null
        items.value[itemIndex.value].budget_subledger =
          formPOItem.budgetInfo.subledger !== ''
            ? formPOItem.budgetInfo.subledger
            : null
        items.value[itemIndex.value].budget_subledger_name =
          formPOItem.budgetInfo.subledger !== ''
            ? formPOItem.budgetInfo.subledger_name
            : null

        items.value[itemIndex.value].budget_subledger =
          formPOItem.budgetInfo.subledger
        items.value[itemIndex.value].budget_subsidiary =
          formPOItem.budgetInfo.subsidiary
        items.value[itemIndex.value].budget_code =
          formPOItem.budgetInfo.account_code

        items.value[itemIndex.value].budget_year = formPOItem.bu_year
        items.value[itemIndex.value].budget_name = formPOItem.bu_name

        // items.value[itemIndex.value].uom = formPOItem.uom
        items.value[itemIndex.value].uom = uom.uom_name
        items.value[itemIndex.value].uom_code = uom.uom_code
        items.value[itemIndex.value].use_date = dateFormat(formPOItem.useDate)
        items.value[itemIndex.value].pickup_loc = formPOItem.pickupLoc
        items.value[itemIndex.value].amount = formPOItem.amount
        items.value[itemIndex.value].vat = formPOItem.vat
        items.value[itemIndex.value].qty = formPOItem.qty
        items.value[itemIndex.value].actual_cost = formPOItem.actualCost
        items.value[itemIndex.value].vat_rate = formPOItem.taxVatDefault

        items.value[itemIndex.value].item_category =
          formPOItem.materialInfo.material_group
        items.value[itemIndex.value].item_no =
          formPOItem.materialInfo.material_code
        items.value[itemIndex.value].item_name =
          formPOItem.materialInfo.description
        items.value[itemIndex.value].item_code =
          formPOItem.materialInfo.description_code
        items.value[itemIndex.value].item_type =
          formPOItem.materialInfo.material_type
        items.value[itemIndex.value].unit_price = formPOItem.materialInfo.price
        items.value[itemIndex.value].bargain_discount =
          formPOItem.bargainDiscount
        items.value[itemIndex.value].qty_po_diff = formPOItem.qtyPoDiff
        items.value[itemIndex.value].use_price_type = formPOItem.usePriceType

        items.value[itemIndex.value].wh_tax = formPOItem.whTax
        items.value[itemIndex.value].wh_tax_rate = formPOItem.whTaxDefault

        items.value[itemIndex.value].retention = formPOItem.retention
        items.value[itemIndex.value].retention_rate = formPOItem.retentionRate
        items.value[itemIndex.value].retention_process =
          formPOItem.retentionProcess

        clearFormItem()

        if (items.value[itemIndex.value].gr_item_id) {
          const data = setDataItem(itemIndex.value)
          await api
            .put(
              `/procurement/gr/updateItem/${
                items.value[itemIndex.value].gr_item_id
              }`,
              data
            )
            .then(async res => {
              if (res.code == 200) {
                // items.value[itemIndex.value].gr_item_id = res.data.gr_item_id
                alert.success()
                await checkBudget()
                await getGRItemSummary()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error(e.message)
            })
        } else {
          if (formGR.grID !== null) {
            const data = setDataItem(itemIndex.value)
            await api
              .post('/procurement/gr/insertItem', data)
              .then(async res => {
                if (res.code == 200) {
                  items.value[itemIndex.value].gr_item_id = res.data.gr_item_id
                  alert.success()
                  await checkBudget()
                  await getGRItemSummary()
                } else {
                  if (res.validator) {
                    alert.validatorShow(res.validator)
                  } else {
                    alert.error(res.message)
                  }
                }
              })
              .catch(e => {
                alert.error(e.message)
              })
          }
        }
      } else {
        alert.error()
      }
    }

    const alertBudget = (isLoading, isOver) => {
      if (isLoading) {
        store.commit('global/setOverBudget', {
          message: 'กำลังตรวจสอบ',
          isOver: true,
          show: true
        })
      } else {
        store.commit('global/setOverBudget', {
          message: isOver == 1 ? 'เกินงบประมาณ' : 'อยู่ในงบประมาณ',
          isOver: isOver == 1,
          show: true
        })
      }
    }

    onUnmounted(() => {
      console.log('unmounted page gr form')
      store.commit('global/setLoadingPage', true)
      store.commit('gr/initBtn')
    })

    const lockField = reactive({
      status: false,
      label: '(ไม่สามารถแก้ไขได้)'
    })

    const getGRItemSummary = async () => {
      // if (route.params.id) {
      await api
        .get(
          `${process.env.VUE_APP_API_URL}/procurement/gr/getByGrId/${formGR.grID}`
        )
        .then(res => {
          if (res.code == 200) {
            formPO.itemSummary = res.data.itemSummary
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
      // }
      // await store.commit('global/setLoadingPage', false)
      // return true
    }

    const getGR = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/procurement/gr/getByGrId/${route.params.id}`
          )
          .then(res => {
            if (res.code == 200) {
              confirmPO({
                chosen: res.data.po_info,
                chosenItems: [...res.data.items]
              })

              formPO.discountAllItem = res.data.po_info.discount_all_item
              formPO.shipping.date = res.data.po_info.shipping_date
              formPO.shipping.address = res.data.po_info.shipping_address
              formPO.shipping.recipient = res.data.po_info.shipping_recipient
              formPO.shipping.conditionSend =
                res.data.po_info.shipping_condition_send
              formPO.shipping.conditionPayment =
                res.data.po_info.payment_term_code
              formPO.shipping.checkBy = res.data.po_info.shipping_check_by

              // if (res.data.doc_no_full != '') {
              lockField.status = true
              // }

              // isDraft,
              formGR.companySelected = res.data.gr_comp
              formGR.employeeSelected = res.data.req_id
              formGR.telephone = res.data.telephone
              formGR.poId = res.data.po_id
              formGR.reqDate = res.data.req_date
              formGR.reqDetail = res.data.req_detail
              formGR.invoiceNo = res.data.invoice_no
              formGR.invoiceDate = res.data.invoice_date
              formGR.instalmentNo = res.data.instalment_no
              formGR.instalmentType = res.data.instalment_type
              formGR.glDate = res.data.gl_date
              formGR.docNoFull = res.data.doc_no_full

              formGR.approveResultArray = res.data.approve_result_array
              formGR.documentPathArray = res.data.document_path_array
              formGR.nextStatus = res.data.next_status
              formGR.statusCode = res.data.status_code

              formPO.itemSummary = res.data.itemSummary

              store.commit(
                'gr/setDocumentPathText',
                res.data.document_path_text_array
              )
              store.commit('gr/setDocumentPath', res.data.document_path_array)
              for (const i in res.data.file_attach_array) {
                store.commit('gr/setFile', res.data.file_attach_array[i])
              }

              // store.dispatch('global/loadDocumentSpacialPath', {
              //   compNo: res.data.po_comp
              // })

              if (res.data.ememo_id) {
                formPO.memoSelected = res.data.ememo_id
              }
              if (items.value.length > 0) {
                alertBudget(false, res.data.is_over_budget)
              }

              store.commit('gr/setBtn', { type: 'btnCancel', value: 'hide' })
              if (res.data.status_code != 'GR_DRAFT') {
                store.commit('gr/setBtn', { type: 'btnDraft', value: 'hide' })
              }

              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'CMD_REVIEW'
              ) {
                store.commit('gr/setBtn', { type: 'btnReject', value: 'hide' })
              }
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
      // await store.commit('global/setLoadingPage', false)
      return true
    }

    const getPOItem = async (poItemID, index) => {
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      items.value[index].is_edit = true
      boxItemOpen.value = true
      itemIndex.value = index

      formPOItem.prItemID = items.value[index].pr_item_id
      formPOItem.poItemID = items.value[index].po_item_id
      formPOItem.budgetInfo = {
        year: items.value[index].budget_year,
        bu_name: items.value[index].budget_bu_name,
        bu_code: items.value[index].budget_bu_code,
        bu_type: items.value[index].budget_subledger
          ? 'งบประมาณโครงการ'
          : 'งบประมาณหน่วยงาน',
        subledger: items.value[index].budget_subledger,
        subsidiary: items.value[index].budget_subsidiary,
        account_code: items.value[index].budget_code,
        account_name: items.value[index].budget_name
      }
      formPOItem.bu_year = items.value[index].budget_year
      formPOItem.bu_name = items.value[index].budget_name
      formPOItem.uom = items.value[index].uom
      formPOItem.uomSelected = items.value[index].uom_code
      formPOItem.useDate = items.value[index].use_date
      formPOItem.pickupLoc = items.value[index].pickup_loc
      formPOItem.amount = items.value[index].amount
      formPOItem.vat = parseFloat(numberFormat2(items.value[index].vat))
      formPOItem.qty = items.value[index].qty
      formPOItem.actualCost = items.value[index].actual_cost
      // formPOItem.actualCostTmp = items.value[index].actual_cost
      formPOItem.taxVatDefault = items.value[index].vat_rate
      formPOItem.materialInfo.material_group = items.value[index].item_category
      formPOItem.materialInfo.material_code = items.value[index].item_no
      formPOItem.materialInfo.description = items.value[index].item_name
      formPOItem.materialInfo.description_code = items.value[index].item_code
      formPOItem.materialInfo.material_type = items.value[index].item_type
      formPOItem.materialInfo.price = items.value[index].unit_price
      formPOItem.taxRate = items.value[index].tax_rate
      formPOItem.glOffset = items.value[index].gl_offset
      formPOItem.catCode = items.value[index].cat_code
      formPOItem.bargainDiscount = items.value[index].bargain_discount
      formPOItem.usePriceType = items.value[index].use_price_type
      formPOItem.qtyPoDiff = items.value[index].qty_po_diff
      formPOItem.whTax = parseFloat(numberFormat2(items.value[index].wh_tax))
      formPOItem.whTaxDefault = items.value[index].wh_tax_rate
      formPOItem.taxWhProcess = items.value[index].wh_tax > 0
      formPOItem.retention = items.value[index].retention
      formPOItem.retentionRate = items.value[index].retention_rate
      formPOItem.retentionProcess = items.value[index].retention_process

      await api
        .get(
          `${process.env.VUE_APP_API_URL}/procurement/gr/getItemRemain?po_id=${formGR.poId}&po_item_id=${items.value[index].po_item_id}`
          // `${process.env.VUE_APP_API_URL}/procurement/gr/getItemRemain?po_id=105&po_item_id=294`
        )
        .then(res => {
          if (res.code == 200) {
            remain.sumActualCost = numberFormat(res.data.sum_actual_cost)
            remain.instalmentLatest = numberFormat(res.data.instalment_latest)
            remain.remainActualCost = numberFormat(res.data.remain_actual_cost)
            remain.history = res.data.history
          }
        })

      return true
    }

    const checkBudget = async () => {
      if (!formGR.grID || items.value.length == 0) {
        store.commit('global/resetOverBudget')
        alert.error('กรุณาบันทึกรายการล่าสุด')
        return
      }
      alertBudget(true, 0)
      await api
        .get(`/procurement/gr/checkOverBudgetByDocId/${formGR.grID}`)
        .then(res => {
          if (res.code == 200) {
            alertBudget(false, res.data.is_over_budget)
            if (res.data.is_over_budget) {
              alert.error('เกินงบประมาณ')
            }
          }
          return res.data
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const rejectGR = async () => {
      store.commit('gr/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/procurement/gr/editBeforeApprove/${formGR.grID}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('gr/setBtn', { type: 'btnDraft', value: 'hide' })
            store.commit('gr/setBtn', { type: 'btnSave', value: 'hide' })
            store.commit('gr/setBtn', { type: 'btnReject', value: 'hide' })
            store.commit('gr/setBtnActive', { type: 'btnReject' })
          } else {
            alert.error(res.message)
          }
        })
    }

    const getTaxRate = taxRate => {
      return store.getters['global/getTaxRateText'](taxRate)
    }

    const getCatCode = catCode => {
      return store.getters['global/getCatCodeText'](catCode)
    }

    onMounted(async () => {
      console.log('mounted page gr form')
      await store.dispatch('global/loadCompany')
      // store.dispatch('global/loadTaxRate')
      // store.dispatch('global/loadCatCode')
      // store.dispatch('global/loadCurrency')
      // store.dispatch('global/loadCash')
      store.dispatch('global/loadFileUploadMaxSize')
      store.commit('global/resetOverBudget')
      store.dispatch('gr/loadGrOptionInstalmentType')
      // store.dispatch('gr/loadShippingRecipientList')
      // store.dispatch('gr/loadShippingConditionPaymentList')
      // store.dispatch('pr/loadMaterialFilterOption')
      store.dispatch('global/loadUOM')
      // await store.dispatch('global/loadDocumentSpacialPath', {
      //   compNo: store.state.auth.info.comp_no
      // })

      store.commit('gr/setBtnDisplay', { key: 'btnItemSave', status: true })
      store.commit('gr/setBtnDisplay', { key: 'btnSave', status: formGR.grID })
      store.commit('gr/setBtnDisplay', { key: 'btnDraft', status: true })
      // console.log('mounted: ', companyDefault)
      await getGR()
      // await store.dispatch('gr/loadDocumentPath', {
      //   compNo: companyDefault.value.comp_no,
      //   employeeId: formGR.employeeSelected,
      //   pr_id: null
      // })
      // store.dispatch('gr/loadMemo', { ememoId: formPO.memoSelected })
      // store.dispatch('gr/loadPOList', {
      //   employeeId: formGR.employeeSelected,
      //   company: formGR.companySelected
      // })
      // companyChange()
      if (!formGR.grEdit) {
        await onChangeDocumentPath({ target: 'mounted' })
      }
      await store.commit('global/setLoadingPage', false)
    })

    return {
      loadingPage,
      btnSave,
      btnCancel,
      btnDraft,
      btnReject,
      btnItemSave,
      boxItemOpen,
      toggleBoxItemOpen,
      companyDefault,
      companyOptions,
      orderTypeOptions,
      clearFormItem,
      // currencyOptions,
      // cashOptions,
      // documentSpacialPathOptions,
      // specialPathSelected,
      // memoOptions,
      fileUploadMaxSize,
      instalmentOptions,
      formGR,
      formPO,
      formPOItem,
      getPOItem,
      items,
      // companyChange,
      userInfo,
      saveGR,
      saveItem,
      setBudget,
      setMaterial,
      validateItem,
      setDeleteGRItem,
      confirmDeleteGRItem,
      cancelDeleteGRItem,
      deletePOItemID,
      checkBudget,
      rejectGR,
      numberFormat,
      dateFormat,
      documentPathText,
      lockField,
      uomOptions,
      // showValidator,
      // isValidator,
      poChosen,
      docNoFull,
      // shippingRecipientOption,
      // shippingConditionPaymentOption,
      isLoadingGRList,
      updateItem,
      poList,
      confirmPO,
      modalPODisplay,
      openModalPOList,
      closedModalPOList,
      getTaxRate,
      getCatCode,
      files,
      instalmentNo,
      validateGR,
      calActualCost,
      calVat,
      calTax,
      calVatProcess,
      calTaxProcess,
      calPriceQty,
      onChangeDocumentPath,
      summaryAmount,
      employeeDefault,
      remain,
      calRetention,
      calRetentionProcess
    }
  }
}
</script>

<style scoped>
.vue-select {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e2e8f0;
  border-style: solid;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
